import { RETURN_TASK, RETURN_TASK_SUCCESSFUL, RETURN_TASK_FAILED } from './actionTypes';

export const returnTask = (task,user, history,inbound) => {
    return {
        type: RETURN_TASK,
        payload: { task,user, history, inbound }
    }
}

export const returnTaskSuccessful = (msg) => {
    return {
        type: RETURN_TASK_SUCCESSFUL,
        payload: msg
    }
}

export const returnTaskFailed = (msg) => {
    return {
        type: RETURN_TASK_FAILED,
        payload: msg
    }
}
